import type { ComponentType, FC, ReactElement, ReactNode } from 'react'

import { useExpandableText } from '@skytech/utils'
import { sanitizeProductDescription } from '@skytech/utils/html-sanitization'
import { twJoin } from 'tailwind-merge'

export const ExpandableDescription: FC<{
  description: string
  className?: string
  showFullText?: boolean
  TranslationComponent: ComponentType<
    {
      id?: string
      className?: string
      children?: ReactNode
    } & Record<string, string | ReactElement>
  >
}> = ({ description, className, showFullText = true, TranslationComponent }) => {
  const TComponent = TranslationComponent
  const { textRef, isTextExpandable, isFullTextVisible, onFullTextVisibleSet } =
    useExpandableText(120)

  return (
    <>
      {description.length >= 1 && (
        <div
          ref={textRef}
          className={twJoin(
            'mobile:text-base relative overflow-hidden whitespace-pre-wrap text-justify text-xs',
            isFullTextVisible && '[mask-image:unset] [max-height:unset]',
            !showFullText &&
              isTextExpandable &&
              'max-h-32 [mask-image:linear-gradient(180deg,_#000_60%,_transparent)]',
            className
          )}
        >
          <div dangerouslySetInnerHTML={{ __html: sanitizeProductDescription(description) }} />
        </div>
      )}

      <div
        className={twJoin(
          'mobile:text-base mobile:my-3 mx-0 my-2 w-full justify-center text-xs',
          isTextExpandable ? 'flex' : 'hidden',
          showFullText && 'hidden'
        )}
      >
        <button
          onClick={onFullTextVisibleSet}
          className="border-none bg-transparent hover:underline"
        >
          <TComponent
            id={isFullTextVisible ? 'Les mindre...' : 'Les mer...'}
            className="lower-case"
          />
        </button>
      </div>
    </>
  )
}
